import { ADMIN_THEME } from "@/lib/admin-theme";

// ---------------------------------------------------------------------------
// Scope badge
// ---------------------------------------------------------------------------

export function ScopeBadge({ scope }: { readonly scope: "Vitrine" | "Admin" }) {
  const isVitrine = scope === "Vitrine";
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{
        background: isVitrine ? "rgba(45,90,61,0.1)" : "rgba(199,91,57,0.1)",
        color: isVitrine ? ADMIN_THEME.accent.green : ADMIN_THEME.sidebar.bg,
      }}
    >
      {scope}
    </span>
  );
}

// ---------------------------------------------------------------------------
// Status badge
// ---------------------------------------------------------------------------

export function StatusBadge({ status }: { readonly status: "Actif" | "Inactif" }) {
  const isActive = status === "Actif";
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{
        background: isActive ? "rgba(45,90,61,0.1)" : "rgba(120,113,108,0.1)",
        color: isActive ? ADMIN_THEME.accent.green : "#78716c",
      }}
    >
      <span
        className="mr-1.5 inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: isActive ? ADMIN_THEME.accent.green : "#a8a29e" }}
      />
      {status}
    </span>
  );
}

// ---------------------------------------------------------------------------
// Role badge (API roles: manager | agent)
// ---------------------------------------------------------------------------

export function RoleBadge({ role }: { readonly role: string }) {
  const colorMap: Record<string, { bg: string; text: string }> = {
    manager: {
      bg: "rgba(45,90,61,0.1)",
      text: ADMIN_THEME.accent.green,
    },
    agent: {
      bg: "rgba(120,113,108,0.1)",
      text: "#57534e",
    },
  };
  const colors = colorMap[role] ?? { bg: "rgba(120,113,108,0.1)", text: "#57534e" };
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize"
      style={{ background: colors.bg, color: colors.text }}
    >
      {role}
    </span>
  );
}
